// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"910e618b","907":"6180ffcb"}[chunkId] + ".chunk.js";
};